/** Minimal dependency-free line chart for price/rate history (RTL-safe: plain SVG). */
export function Sparkline({
  points,
  width = 260,
  height = 56,
  stroke = 'var(--navy-l, #1F4E78)',
}: {
  points: number[];
  width?: number;
  height?: number;
  stroke?: string;
}) {
  if (points.length < 2) {
    return <span className="muted">داده کافی برای نمودار نیست</span>;
  }
  const min = Math.min(...points);
  const max = Math.max(...points);
  const span = max - min || 1;
  const pad = 4;
  const step = (width - pad * 2) / (points.length - 1);
  const xy = points
    .map((v, i) => {
      const x = pad + i * step;
      const y = height - pad - ((v - min) / span) * (height - pad * 2);
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label="نمودار تاریخچه"
    >
      <polyline points={xy} fill="none" stroke={stroke} strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}
